import React from 'react';

interface Props {
  icon: React.ReactNode;
  notification?: number | null | undefined | any;
  onClick?: () => void;
}

const IconNotification = ({ icon, notification, onClick }: Props) => {
  return (
    <div
      className="flex justify-center items-center rounded-full relative hover:bg-gray-100 w-[40px] h-[40px] cursor-pointer"
      onClick={onClick}
    >
      {icon}
      {notification > 0 && (
      <div className="flex items-center justify-center rounded-full w-[18px] h-[18px] bg-[#9D2225] text-white absolute top-[-2px] right-[-2px] text-xs font-bold">
          {notification > 9 ? '9+' : notification}
        </div>
      )}
    </div>
  );
};

export { IconNotification };
